import type { IOperatingLocationOverride } from '../types/global/operatingLocation.types';

const STORAGE_KEY = 'thspian:operatingLocationBrowser';

export interface OperatingLocationBrowserStore {
    persistAcrossSessions: boolean;
    override: IOperatingLocationOverride | null;
}

const EMPTY_STORE: OperatingLocationBrowserStore = {
    persistAcrossSessions: false,
    override: null,
};

export function readOperatingLocationBrowserStore(): OperatingLocationBrowserStore {
    if (typeof window === 'undefined') return EMPTY_STORE;
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return EMPTY_STORE;
        const parsed = JSON.parse(raw) as Partial<OperatingLocationBrowserStore>;
        return {
            persistAcrossSessions: Boolean(parsed.persistAcrossSessions),
            override: parsed.override?.country_code ? parsed.override : null,
        };
    } catch {
        return EMPTY_STORE;
    }
}

export function writeOperatingLocationBrowserStore(store: OperatingLocationBrowserStore): void {
    if (typeof window === 'undefined') return;
    try {
        if (!store.persistAcrossSessions && !store.override) {
            window.localStorage.removeItem(STORAGE_KEY);
            return;
        }
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch {
        // ignore quota / private mode
    }
}

export function clearOperatingLocationBrowserStore(): void {
    if (typeof window === 'undefined') return;
    try {
        window.localStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore
    }
}

export function syncOperatingLocationBrowserStoreFromRedux(
    persistAcrossSessions: boolean,
    override: IOperatingLocationOverride | null | undefined,
): void {
    if (!persistAcrossSessions) {
        writeOperatingLocationBrowserStore({ persistAcrossSessions: false, override: null });
        return;
    }
    writeOperatingLocationBrowserStore({
        persistAcrossSessions: true,
        override: override?.country_code ? override : null,
    });
}
